export const userDeviceInfoTypes = {
    POST_REQUEST: 'UDI_POST_REQUEST',
    POST_SUCCESS: 'UDI_POST_SUCCESS',
    POST_FAILURE: 'UDI_POST_FAILURE',
};
